<template>
    <qd-admin-auth pid="146">
        <router-view></router-view>
    </qd-admin-auth>
</template>

<script>
export default {
    data() {
        return {};
    },
    beforeRouteEnter(to, from, next) {
        if (to.hash.length) {
            const path = to.fullPath.replace(/#/g, '');
            next(path);
        } else {
            next();
        }
	},

    methods: {}
};
</script>
<style lang="less" scoped>
.qidian-admin-auth {
    height: calc(100vh - 120px);
}
</style>
